import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

interface StripeConfigResponse {
    publishable_key: string;
}

export function useStripeConfig() {
    return useQuery<StripeConfigResponse>({
        queryKey: ['stripe-config'],
        queryFn: async () => {
            const { data } = await api.get<StripeConfigResponse>('/billing/stripe-config');
            return data;
        },
        staleTime: 5 * 60 * 1000, // 5 minutes — config rarely changes
    });
}
